import React from "react";
import MobileTabs from "../../components/MobileTabs";
import Filters from "../../components/filter/Filter";
import { useFilterContext } from "../../context/FilterContext";

const MoMt = () => {
  
  return (
    <div className="flex flex-col space-y-10">
      <section>
        <Filters />
      </section>
      <section>
        <MobileTabs />
      </section>
    </div>
  );
};

export default MoMt;